import { initUiLibrary } from "mf-ui-components";
import React from "react";
import ReactDOM from "react-dom";

import { App } from "./App";

initUiLibrary();

ReactDOM.render(<App />, document.getElementById("root"));
